var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isAddNewAccountLicenseFailedModalVisible,
          expression: "isAddNewAccountLicenseFailedModalVisible"
        }
      ]
    },
    [
      _c("transition", { attrs: { name: "slide" } }, [
        _c("div", { class: _vm.type == 2 ? "modal-mask" : "modal-mask1" }, [
          _c(
            "div",
            {
              staticClass: "modal-dialog modal-dialog-slideout modal-lg",
              staticStyle: { "max-width": "100%" }
            },
            [
              _c("div", { staticClass: "modal-content p-2" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("div", { staticStyle: { width: "100%" } }, [
                    _c(
                      "a",
                      {
                        staticClass: "text-uppercase text-muted pt-1",
                        attrs: { href: "javascript:void(0);" },
                        on: { click: _vm.hide }
                      },
                      [
                        _c("img", {
                          staticClass: "back_icon mr-2",
                          attrs: {
                            src: require("@/assets/manager/back_button_icon.png")
                          }
                        }),
                        _vm._v("Back")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "close float-right",
                        attrs: { type: "button" },
                        on: { click: _vm.hide }
                      },
                      [
                        _c("span", { attrs: { "aria-hidden": "true" } }, [
                          _vm._v("×")
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "clearfix" })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("div", { staticClass: "row mb-4" }, [
                    _c("div", { staticClass: "col-9 pl-3" }, [
                      _c(
                        "div",
                        { staticClass: "h3 d-inline mr-2 text-uppercase" },
                        [_vm._v("Add Subscription")]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12" }, [
                      _c("div", { staticClass: "successPanel" }, [
                        _c("div", { staticClass: "success_col_1" }, [
                          _c("p", { staticClass: "success-note" }, [
                            _vm._v(
                              "\n                                            Your payment transaction has failed and the subscription is not purchased.\n                                        "
                            )
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "row justify-content-md-center closebtn_div"
                    },
                    [
                      _c("div", { staticClass: "col-6" }, [
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-sm btn-blue closeBtn text-center",
                            attrs: { type: "button" },
                            on: { click: _vm.closeModal }
                          },
                          [_vm._v("Close Window")]
                        )
                      ])
                    ]
                  )
                ])
              ])
            ]
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-65acd66e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65acd66e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/enterpriseadmin/add_new_account_license_failed_modal.vue
// module id = null
// module chunks = 